export default "__VITE_ASSET__D_hXnbLv__"